import {Provider} from 'react-redux';
//import {createStore, applyMiddleware} from 'redux';

/*use compose for dev mode for redux */
import {createStore, applyMiddleware,compose} from 'redux';

import thunk from 'redux-thunk';
import promise from 'redux-promise';
import logger from 'redux-logger';
// Reducers
import allReducers from '../reducers';


// const configureStore = createStore(
//     allReducers,
//     applyMiddleware(thunk, promise)
// );

/* development mode for redux */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const configureStore = createStore(
    allReducers,
    composeEnhancers(applyMiddleware(thunk, promise))
);



export default configureStore;

//applyMiddleware(thunk, promise, logger)


// WEBPACK FOOTER //
// ./src/store/configureStore.js